import { createRoot } from '@wordpress/element';
import App from './admin/App';

// Initialize the React app when DOM is ready.
document.addEventListener('DOMContentLoaded', () => {
    // Dashboard.
    const dashboardRoot = document.getElementById('aibp-dashboard-root');
    if (dashboardRoot) {
        const root = createRoot(dashboardRoot);
        root.render(<App />);
    }

    // Settings page.
    const settingsRoot = document.getElementById('aibp-settings-root');
    if (settingsRoot) {
        const root = createRoot(settingsRoot);
        root.render(<App />);
    }
});
